/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { Checkbox } from 'sharedComponents/Checkbox';

const Option = React.memo((props) => {
    const { isSelected, label } = props;

    const handleCheckboxToggle = () => {
        props.selectOption(props.data);
    };

    return (
        <components.Option {...props}>
            <div className='subscription-type'>
                <Checkbox
                    checked={isSelected}
                    id={label}
                    onToggle={handleCheckboxToggle}
                />
                <label htmlFor={label} className='subscription-type-label'>
                    {label}
                </label>
            </div>
        </components.Option>
    );
});

Option.propTypes = {
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    selectOption: PropTypes.func,
    data: PropTypes.object,
};

export default Option;
